import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class NewsResource extends BaseCamelCasedResource {
    pk() {
        return this.newsItemId?.toString();
    }
}
NewsResource.urlRoot = legacyApiResourceUrl("Information/GetNews");
export { NewsResource };
//# sourceMappingURL=NewsResource.js.map